import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCapIcon, LandmarkIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { educationCredential, governanceExposure } from '../data/education';
export function BoardEducation() {
  return <section id="governance" className="bg-white py-24 lg:py-32" data-id="element-29" data-mp="29u610y5jtlof">
      <div className="max-w-content mx-auto px-6 lg:px-10" data-id="element-30" data-mp="29smn3e7d7mpt">
        <SectionHeading eyebrow="09 — Board Experience, Education & Civic Leadership" title="Academic Foundation &amp; Stakeholder Engagement" data-id="element-31" data-mp="2nsnkgjof8c0j" />

        <div className="mt-14 grid md:grid-cols-2 gap-6" data-id="element-32" data-mp="2xj8r8ue90muj">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-slate-50 border border-slate-200 p-8 lg:p-10" data-id="element-33" data-mp="2xip85acv3sex">
            <GraduationCapIcon className="h-6 w-6 text-gold-dark" strokeWidth={1.5} data-id="element-34" data-mp="31j98snwn9e5t" />
            <h3 className="mt-4 font-serif text-lg font-semibold text-navy" data-id="element-35" data-mp="n3po8jwudayf">Academic Qualification</h3>
            <p className="mt-3 text-sm leading-relaxed text-slate-600" data-id="element-36" data-mp="s2sj5bj3y0so">
              {educationCredential.qualification}
            </p>
            <p className="mt-1 text-sm text-slate-500" data-id="element-37" data-mp="11zf37y3m0ntn">{educationCredential.institution}</p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          ease: [0.23, 1, 0.32, 1],
          delay: 0.08
        }} className="bg-slate-50 border border-slate-200 p-8 lg:p-10" data-id="element-38" data-mp="15zfreagigddw">
            <LandmarkIcon className="h-6 w-6 text-gold-dark" strokeWidth={1.5} data-id="element-39" data-mp="1krg75ev8r49x" />
            <h3 className="mt-4 font-serif text-lg font-semibold text-navy" data-id="element-40" data-mp="1pq17rfeenpyw">Governance &amp; Stakeholder Engagement</h3>
            <ul className="mt-4 space-y-3" data-id="element-41" data-mp="1tnyyimntqk4e">
              {governanceExposure.map(item => <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-slate-600" data-id="element-42" data-mp="3qol9xe487m14">
                  <span className="mt-2 h-1.5 w-1.5 rounded-full bg-gold shrink-0" data-id="element-43" data-mp="3lpi780bpxrwb" />
                  {item}
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}